import { isTestOrDevEnvironment } from '@lib/config-loader';
import { LogLevel } from '@logger/core';
import { BAD_CREDENTIALS } from '@resource/i18n-shapes';
import {
  HttpError,
  HttpErrorJSON,
  isHttpError,
} from '@service-layer-utils/errors';
import { getReasonPhrase, StatusCodes } from 'http-status-codes';

import { AuthenticationErrorType } from './AuthenticationErrorType';

export class BadCredentialsError extends HttpError implements isHttpError {
  private readonly internalMessage: string;

  private readonly errorType: AuthenticationErrorType;

  constructor(internalMessage: string, errorType: AuthenticationErrorType) {
    super(StatusCodes.UNAUTHORIZED);
    this.internalMessage = internalMessage;
    this.errorType = errorType;
  }

  toJSON(toClient?: boolean): HttpErrorJSON {
    return this.convertToHttpErrorJSON({
      status: this.httpCode,
      type: !toClient
        ? BadCredentialsError.name
        : getReasonPhrase(this.httpCode),
      reason: isTestOrDevEnvironment()
        ? this.internalMessage
        : getReasonPhrase(this.httpCode),
      i18n: BAD_CREDENTIALS,
      level: LogLevel.INFO,
    });
  }
}
